import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/templates`;
const THUMBS = `${BASE}/macro-gif/thumbnails`;
const IMAGE_THUMBS = `${BASE}/thumbnails/macro-gif`;

export const macroGIF = defineTemplate({
  mode: 'legacy',
  id: 'macro-gif',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Macro GIF',
  thumbnail: {
    url: `${THUMBS}/macro-gif.png`,
    optimizedUrl: `${THUMBS}/optimized/macro-gif.png`,
    hoverVideo: `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/Ejemplos/prueba1.gif`,

    aspectRatio: 'square'
  },
  previewByResolution: {
    '1080x1080': { kind: 'video', url: `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/Ejemplos/prueba1.gif` }
  },
  hidePromptTemplate: true,
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'text1',
      label: 'Slogan',
      type: 'input',
      placeholder: 'Máx. 20 caracteres por línea. Presioná Enter para saltos de línea.',
      required: true,
      multiline: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'image1',
      label: 'Imagen principal',
      type: 'visual-select',
      required: false,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png',
      options: [
        {
          id: 'MAG7Z7hv1iQ',
          value: 'MAG7Z7hv1iQ',
          label: '1',
          imageUrl: `${IMAGE_THUMBS}/MAG7Z7hv1iQ.png`,
          backgroundColor: '#0139E3'
        },
        {
          id: 'MAG7Z9KCteA',
          value: 'MAG7Z9KCteA',
          label: '2',
          imageUrl: `${IMAGE_THUMBS}/MAG7Z9KCteA.png`,
          backgroundColor: '#0139E3'
        },
        {
          id: 'MAG7Z8xs-SA',
          value: 'MAG7Z8xs-SA',
          label: '3',
          imageUrl: `${IMAGE_THUMBS}/MAG7Z8xs-SA.png`,
          backgroundColor: '#0139E3'
        }
      ]
    }
  ]
});
